export const STORE_ITEMS = 'STORE_ITEMS';
export const storeItems = (items) => ({
  type: STORE_ITEMS,
  items,
});
